import { runOf, usePiiBackfillStatus } from "@/api/pii-vault/use-pii-backfill";
import { Card, CardContent } from "@babackapp/ui/components/card";
import { PiiBackfillControls } from "./pii-backfill-controls";
import { PiiBackfillProgress } from "./pii-backfill-progress";

const COLLECTION_COUNT = 3;

/**
 * Super-admin control of the vault backfill (RGPD-PII-VAULT-PLAN.md, step 2).
 * Nothing runs until a shop is started here: the vault is filled shop by shop.
 */
export function PiiBackfillCard({ shopId }: { shopId: string }) {
  const status = usePiiBackfillStatus(shopId);
  // Rows of an older vault model do not count: the shop is to record again.
  const states = runOf(status.data?.states ?? [], "record").filter(
    (state) => state.isCurrentModel,
  );
  const isComplete =
    states.length === COLLECTION_COUNT && states.every((state) => state.isDone);

  return (
    <Card>
      <CardContent className="py-4 space-y-4">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="font-medium">Rattrapage du coffre</h2>
            <p className="text-sm text-muted-foreground">
              Copie les données personnelles des retours, colis et commandes
              déjà en base vers le coffre. Rien n'est supprimé et aucun écran ne
              change de source. Retours et colis sont toujours pris en entier.
            </p>
          </div>
          <PiiBackfillControls shopId={shopId} states={states} />
        </div>

        {isComplete && (
          <p className="text-sm text-emerald-700">
            Rattrapage terminé pour cette boutique.
          </p>
        )}

        {states.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            Jamais lancé pour cette boutique.
          </p>
        ) : (
          <div className="space-y-3">
            {states.map((state) => (
              <PiiBackfillProgress key={state.collection} state={state} />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
